import toast from "react-hot-toast";
import moment from "moment";
export const ErrorHandlerFunc = (error) => {
  const message =
    (error.response && error.response.data && error.response.data.message) ||
    error.message ||
    error.toString();
  toast.error(`${message}`);
};

export const getProgress = (startDate, endDate) => {
  let difference = moment(endDate).diff(startDate, "days");

  //days remaining
  let seconddifference = moment(endDate).diff(moment(), "days");
  if (seconddifference / difference < 0 || seconddifference / difference > 1) {
    return 100;
  } else {
    return 100 - (seconddifference / difference) * 100;
  }
};

export function getInterestPercentagevalue(percentage, totalAmount) {
  const percent = percentage / 100;
  const amountValue = percent * Number(totalAmount);
  const roundedAmount = Math.round(amountValue * 100) / 100;

  return Number(roundedAmount);
}

export const copytext = async (text, message) => {
  await navigator.clipboard.writeText(text);
  toast.success(message);
  return;
};

export function calculateDayPercentage(startDate, endDate) {
  const start = moment(startDate);
  const end = moment(endDate);
  const totalDays = end.diff(start, "days");
  const daysPassed = moment().diff(start, "days");
  const percentage = (daysPassed / totalDays) * 100;
  return `${percentage}%`;
}

export function calculatePercentageSaved(amount, target) {
  const percentage = (amount / target) * 100;
  return `${percentage.toFixed(2)}%`;
}

function numberToWords(number) {
  const singleDigits = [
    "Zero",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
  ];
  const twoDigits = [
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];
  const tensMultiple = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];

  const tensPower = ["Hundred", "Thousand"];

  if (number < 10) return singleDigits[number];
  if (number < 20) return twoDigits[number - 10];
  if (number < 100)
    return (
      tensMultiple[Math.floor(number / 10)] +
      (number % 10 ? " " + singleDigits[number % 10] : "")
    );
  if (number < 1000)
    return (
      singleDigits[Math.floor(number / 100)] +
      " Hundred" +
      (number % 100 ? " " + numberToWords(number % 100) : "")
    );
  if (number < 100000)
    return number < 2000
      ? "One Thousand" +
          (number % 1000 ? " " + numberToWords(number % 1000) : "")
      : numberToWords(Math.floor(number / 1000)) +
          " Thousand" +
          (number % 1000 ? " " + numberToWords(number % 1000) : "");

  //i can have to up to 900, 000

  // Extend this function for higher numbers if necessary
  return "Number too large";
}

export function convertAmountToWords(amount) {
  let [naira, kobo] = amount.toString().split(".");
  naira = parseInt(naira, 10);
  kobo = parseInt(kobo || "0", 10);
  let words = "";

  if (naira > 0) {
    words += numberToWords(naira) + " Naira";
  } else {
    words += "Zero Naira";
  }

  words += " ";

  if (kobo > 0) {
    words += numberToWords(kobo) + " Kobo";
  } else {
    words += "Zero Kobo";
  }
  return words;
}

export const stringifyFilter = (filter, allowNull) => {
  let filterString = "";
  if (!filter || typeof filter !== "object") {
    return "";
  }
  for (const item in filter) {
    if (
      item &&
      filter[item] !== undefined &&
      filter[item] !== "" &&
      (filter[item] !== null || allowNull)
    ) {
      filterString = filterString ? `${filterString}&` : filterString;
      filterString += `${item}=${filter[item]}`;
    }
  }
  filterString = filterString ? `?${filterString}` : filterString;
  return filterString;
};

export const getSavingsDays = (frequency) => {
  let days;
  switch (frequency) {
    case "Daily":
      days = 30;
      break;

    case "Weekly":
      days = 7;
      break;
    case "Monthly":
      days = 1;
      break;
    default:
      break;
  }

  return days;
};
